export default __webpack_public_path__ + "static/media/an3.3b7609ee.jpg";